



































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { extractDistinctById, extractDistinctProp } from '../../../utils/groupBy';
import { ExportCatalogType } from '../../../enum/ExportCatalogType';

@Component({
  name: 'GestionMetas',  
})
export default class GestionMetas extends Vue {
  private loading = false
  private showError = false   
  
  private get filterGrouId(){
    return this.$store.myGetters.filterGrouId
  }
  private set filterGrouId(value){
    this.$store.myActions.UI_SET_FILTER_GROUPID(value)
  }

  private get filterDbName(){
    return this.$store.myGetters.filterDbName
  }
  private set filterDbName(value){
    this.$store.myActions.UI_SET_FILTER_DBNAME(value)
  }
    
  private get filterDbKey(){
    return this.$store.myGetters.filterDbKey
  }
  private set filterDbKey(value){
    this.$store.myActions.UI_SET_FILTER_DBKEY(value)
  }
  
  private get filterType(){
    return this.$store.myGetters.filterType
  }
  private set filterType(value){
    this.$store.myActions.UI_SET_FILTER_TYPE(value)
  }
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }
  

  private get metasList() {
    return this.$store.myGetters.metasList
  }

  private get search(){
    return this.$store.myGetters.searchMeta
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_META(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortMetaDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_META_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortMetaBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_META_BY(value)
  }

  private get metaGroupsFilterList(){
    return [{id:0,libelle:'Tous'},...this.$store.myGetters.metaGroupsList.filter(m => this.metasList.some(me => me.mtgId == m.id))]
  }

  private get metaFluxTypeFilterList() {    
    return [ExportCatalogType.OffersAndTree,...extractDistinctProp(this.metasList,it => it.mtaFluxTyp)]
  }


  private get metaDbKeyFilterList() {    
    return ['Tous',...extractDistinctProp(this.metasList,it => it.mtaKey)]
  }

  private get metaDbNameFilterList() {    
    return ['Tous',...extractDistinctProp(this.metasList,it => it.mtaDbname)]
  }

  private get metaGroups(){
    return this.$store.myGetters.metaGroups
  }

  private get headers(){
    return [
      { text: 'ID', value: 'id', width:80 },      
      { text: 'Type', value: 'mtaFluxTyp', width:130,
        filter : (item:string) => this.filterType == ExportCatalogType.OffersAndTree || item == this.filterType
      },
      { text: 'Group', value: 'mtgId', width:200,
        filter : (item:number) => this.filterGrouId == 0 || item == this.filterGrouId
      },    
      { text: 'Key', value: 'mtaKey' , width:200,
        filter : (item:string) =>  this.filterDbKey == 'Tous' || item == this.filterDbKey
      },
      { text: 'Db Name', value: 'mtaDbname', width:200,
        filter : (item:string) => this.filterDbName == 'Tous' || item == this.filterDbName
      },
      { text: 'Meta', value: 'libelle' },
      { text: 'Position', value: 'mtaPos' }
    ]
  } 

  created() {
    this.loading = true
    this.$store.myActions.CATALOGUE_META_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyMetas',params:{mtaId:item.id}})
  } 

  addMeta(){
    //@ts-ignore
    this.$router.push({name:'ModifyMetas',params:{mtaId:0}})
  } 
 
}
